import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_FILE_HEART: GlameraIconDefinition = {
  name: 'file-heart',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-file-heart-body">
      <path d="M13 22h5a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v7"></path>
      <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
      <path class="glm-file-heart-heart" d="M3.62 18.8A2.25 2.25 0 1 1 7 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a1 1 0 0 1-1.507 0z"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-file-heart-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './file-heart.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FileHeartIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_FILE_HEART;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
